if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));

      const threshold = freeShippingThreshold / 100;
      const current = cartTotal / 100;

      const progress = Math.min(
        (cartTotal / (freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1))) * 100,
        100
      );

			const remaining = Math.max(
		0,
		Math.round(threshold - current)
		);

		let title = '';

		if (current >= threshold) {
		title = '🎉 FREE Shipping Unlocked!';
		} else {
		title = `🎁 Unlock FREE Shipping by adding just ₹${remaining} more`;
		}

      this.innerHTML = `
  <div class="shipping-progress-wrapper">

    <div class="shipping-progress-title">
      ${title}
    </div>

    

    <div class="shipping-progress-bar-wrapper">

      <span class="shipping-goal-label">
        Goal: ₹${Math.round(threshold)}
      </span>

      <div class="shipping-progress-bar">
        <div class="shipping-progress-fill" style="width:${progress}%"></div>
      </div>

    </div>

  </div>
`;
}  

    _formatMoney(cents, format) {

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);

    }

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}